import React, { useState, useEffect } from "react";

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: "/gal1.jpg",
      title: " Wedding Ceremonies",
      subtitle: "Create magical moments in our enchanting venues",
      overlay: "Dream weddings come true here"
    },
    {
      image: "/gal4.jpg",
      title: " Accommodations",
      subtitle: "Luxury stays ",
      overlay: "Comfort meets elegance"
    },
   
    {
      image: "/gal2.jpg",
      title: "Luxurious Reception Halls",
      subtitle: "Celebrate your love in grandeur and style",
      overlay: "Where love stories unfold"
    },
    {
      image: "/gal3.jpg",
      title: "Romantic Accommodations",
      subtitle: "Luxury stays for you and your guests",
      overlay: "Comfort meets elegance"
    },
    {
      image: "/gal6.jpg",
      title: "Pre-Wedding Events",
      subtitle: "Host your mehndi, haldi, or cocktail night in style",
      overlay: "Celebrate every moment leading to the big day"
    },
    {
      image: "/gal7.jpg",
      title: "Wedding Decor & Themes",
      subtitle: "Customizable decor to match your love story",
      overlay: "From floral fantasy to royal elegance"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-container">
      {/* Hero Section with Slider */}
      <a href="#about" className="scroll-indicator">
          ↓
        </a>
      <section className="hero-section">
        <div className="hero-slider">
          <div className="slider-container">
            <div
              className="slider-track"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {slides.map((slide, index) => (
                <div key={index} className="slide">
                  <div className="slide-image">
                    <img src={slide.image} alt={slide.title} />
                    <div className="slide-gradient"></div>
                  </div>
                  <div className="slide-content">
                    <div className="slide-overlay">
                      <span className="slide-badge">{slide.overlay}</span>
                      <h1>{slide.title}</h1>
                      <p>{slide.subtitle}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button className="slider-btn prev" onClick={prevSlide}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <button className="slider-btn next" onClick={nextSlide}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>

            <div className="slider-dots">
              {slides.map((_, index) => (
                <button
                  key={index}
                  className={`dot ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>
          </div>
        </div>
       
      </section>

      <style jsx>{`
        html {
          scroll-behavior: smooth;
        }

        .home-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        }

        .hero-section {
          position: relative;
          display: flex;
          align-items: center;
          overflow: hidden;
          min-height: calc(100vh - 75px);

        }

        .hero-slider {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
        }

        .slider-container {
          position: relative;
          width: 100%;
          height: 100%;
          overflow: hidden;
        }

        .slider-track {
          display: flex;
          height: 100%;
          transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }

        .slide {
          min-width: 100%;
          height: 100%;
          position: relative;
        }

        .slide-image {
          width: 100%;
          height: 100%;
          position: relative;
        }

        .slide-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .slide-content {
          position: absolute;
          top: 0;
          left: 35px;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding: 0 5%;
        }

        .slide-overlay {
          max-width: 600px;
          color: white;
          text-align: left;
        }

        .slide-badge {
          display: inline-block;
          background: rgba(255,255,255,0.95);
          color: #333;
          backdrop-filter: blur(10px);
          padding: 8px 20px;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 600;
          margin-bottom: 20px;
          border: 1px solid rgba(255,255,255,0.3);
          box-shadow: 0 4px 15px rgba(0,0,0,0.2);
        }

        .slide-overlay h1 {
          font-size: 3.5rem;
          font-weight: 700;
          margin-bottom: 20px;
          line-height: 1.1;
          color: #ffffff;
          text-shadow: 3px 3px 8px rgba(0,0,0,0.8), 1px 1px 4px rgba(0,0,0,0.9);
        }

        .slide-overlay p {
          font-size: 1.3rem;
          opacity: 0.95;
          line-height: 1.6;
          font-weight: 500;
          color: #ffffff;
          text-shadow: 2px 2px 6px rgba(0,0,0,0.8), 1px 1px 3px rgba(0,0,0,0.9);
        }

        .slider-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255,255,255,0.15);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255,255,255,0.3);
          width: 60px;
          height: 60px;
          border-radius: 50%;
          cursor: pointer;
          transition: all 0.3s ease;
          z-index: 10;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .slider-btn:hover {
          background: rgba(255,255,255,0.25);
          transform: translateY(-50%) scale(1.1);
        }

        .slider-btn.prev {
          left: 30px;
        }

        .slider-btn.next {
          right: 30px;
        }

        .slider-dots {
          position: absolute;
          bottom: 30px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 12px;
          z-index: 10;
        }

        .dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          border: 2px solid rgba(255,255,255,0.5);
          background: transparent;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .dot.active {
          background: white;
          border-color: white;
          transform: scale(1.2);
        }

        .scroll-indicator {
          position: absolute;
          text-decoration: none;
          bottom: 20px;
          top: 80%;
          left: 50%;
          transform: translateX(-50%);
          color: white;
          font-size: 2rem;
          opacity: 0.8;
          z-index: 9999;
          animation: bounce 2s infinite;
        }

        @keyframes bounce {
          0%, 100% {
            transform: translate(-50%, 0);
          }
          50% {
            transform: translate(-50%, 10px);
          }
        }

        @media (max-width: 1024px) {
          .hero-section {
            flex-direction: column;
          }
            
          .slide-content {
            padding: 0 5%;
            justify-content: center;
            text-align: center;
            left: 0;
          }

          .slide-overlay h1 {
            font-size: 2.5rem;
            text-shadow: 3px 3px 8px rgba(0,0,0,0.85), 1px 1px 4px rgba(0,0,0,0.95);
          }

          .slide-overlay p {
            font-size: 1.2rem;
            text-shadow: 2px 2px 6px rgba(0,0,0,0.85), 1px 1px 3px rgba(0,0,0,0.95);
          }
        }

        @media (max-width: 768px) {
          .slide-overlay h1 {
            font-size: 1.8rem;
            text-shadow: 4px 4px 10px rgba(0,0,0,0.9), 2px 2px 6px rgba(0,0,0,0.95);
            line-height: 1.2;
          }

          .slide-overlay p {
            font-size: 1rem;
            text-shadow: 3px 3px 8px rgba(0,0,0,0.9), 1px 1px 4px rgba(0,0,0,0.95);
            font-weight: 600;
          }

          .slide-badge {
            font-size: 0.8rem;
            padding: 6px 16px;
            margin-bottom: 15px;
          }

          .slider-btn {
            width: 50px;
            height: 50px;
          }

          .slider-btn.prev {
            left: 15px;
          }

          .slider-btn.next {
            right: 15px;
          }

          .slide-content {
            padding: 0 3%;
          }

          .slide-gradient {
            background: linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0.6) 100%);
          }
        }

        @media (max-width: 480px) {
          .slide-overlay h1 {
            font-size: 1.5rem;
            text-shadow: 5px 5px 12px rgba(0,0,0,0.95), 2px 2px 6px rgba(0,0,0,1);
            line-height: 1.3;
            margin-bottom: 15px;
          }

          .slide-overlay p {
            font-size: 0.9rem;
            text-shadow: 4px 4px 10px rgba(0,0,0,0.95), 2px 2px 6px rgba(0,0,0,1);
            font-weight: 600;
            line-height: 1.5;
          }

          .slide-badge {
            font-size: 0.75rem;
            padding: 5px 14px;
            margin-bottom: 12px;
          }

          .slider-btn {
            width: 45px;
            height: 45px;
          }

          .slider-btn.prev {
            left: 10px;
          }

          .slider-btn.next {
            right: 10px;
          }

          .slide-content {
            padding: 0 2%;
          }

          .slider-dots {
            bottom: 20px;
          }

          .dot {
            width: 10px;
            height: 10px;
          }

          .slide-gradient {
            background: linear-gradient(135deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0.7) 100%);
          }

          .scroll-indicator {
            font-size: 1.8rem;
            bottom: 15px;
          }
        }
      `}</style>
    </div>
  );
};

export default Home;

